import React from 'react';
import AdminLayout from './components/adminlayout';
import TermsEdit from './components/termsedit';

const Terms = () => (
    <AdminLayout>
        <div className='p-6'>
            <div className='bg-white rounded-lg border border-gray-200 p-6'>
                <TermsEdit />
            </div>
        </div>
    </AdminLayout>
);
export default Terms;
